module.exports = __webpack_public_path__ + "img/SFB2.ebb4a792.jpg";